
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from 'firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyBTs1lo7qlFx16HRM-h2jBExMvdQ3rFN90",
  authDomain: "yesid-web-demo.firebaseapp.com",
  databaseURL: "https://yesid-web-demo-default-rtdb.firebaseio.com",
  projectId: "yesid-web-demo",
  storageBucket: "yesid-web-demo.appspot.com",
  messagingSenderId: "640721008315",
  appId: "1:640721008315:web:61281db3cfff2b86249b9e",
  measurementId: "G-7MGVGG8GCV"
};


export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);